<template>
  <v-card class="card-container">
    <div class="main-toolbar mb-4">
      <div class="icon-back">
        <v-icon color="white"> mdi-google-analytics </v-icon>
      </div>

      <span class="main-toolbar-title">Analisadores</span>
    </div>

    <div>
      <v-tabs v-model="tab" align-with-title color="secondary">
        <v-tab> Analisadores </v-tab>
        <v-tab> Templates </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <Analyser></Analyser>
        </v-tab-item>
        <v-tab-item>
          <Template></Template>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-card>
</template>

<script>
import Analyser from './components/analyser/analysers.vue'
import Template from './components/templates/templates.vue'
export default {
  name: 'Analysers',

  components: {
    Analyser,
    Template,
  },

  data() {
    return {
      tab: 0,
    }
  },
}
</script>

<style scoped></style>
